/**
 * All Russian strings (GDD C13: strings live only in `src/content/strings/ru/<module>.ts`). Each module exports a flat
 * record of FULL keys (`'<module>.<…>'`); this file merges them (a duplicate key throws at boot and in tests).
 * Player-facing names come from `src/content/glossary.ts` (GDD §4, F4).
 */
import { mergeStringTables, type StringTable } from '../../../shared';
import { app } from './app';
import { cards } from './cards';
import { combat } from './combat';
import { creature } from './creature';
import { debug } from './debug';
import { explore } from './explore';
import { meta } from './meta';
import { ui } from './ui';
import { equipment } from './equipment';

/** Every module table, by module name (lint tests iterate it). */
export const RU_MODULES: Readonly<Record<string, StringTable>> = { app, cards, combat, creature, debug, explore, meta, ui, equipment };

/** The merged Russian table handed to `createTranslator`. */
export const RU_STRINGS: StringTable = mergeStringTables(...Object.values(RU_MODULES));
